var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116 116",
    style: {
      enableBackground: "new 0 0 116 116"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,82.4c0.8-0.8,2-1.3,3.2-1.3h32.3c2.8,0,5.4-1.1,7.4-3.1c2-2,3.1-4.6,3.1-7.4V30.4c0-2.8-1.1-5.4-3.1-7.4 c-2-2-4.6-3.1-7.4-3.1H26.8c-2.8,0-5.4,1.1-7.4,3.1s-3.1,4.6-3.1,7.4v40.3c0,2.8,1.1,5.4,3.1,7.4s4.6,3.1,7.4,3.1h5v0.3 c1.9,0.7,3.2,2.5,3,4.6l-0.9,13.5L53.7,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,16.6c-3.7-3.7-8.6-5.7-13.8-5.7H26.8c-5.2,0-10.1,2-13.8,5.7c-3.7,3.7-5.7,8.6-5.7,13.8v40.3c0,5.2,2,10.1,5.7,13.8 c3.4,3.4,7.8,5.4,12.5,5.7l-1.4,19.5c-0.1,1.2,0.3,2.3,1.1,3.2c0.8,0.9,1.9,1.5,3.1,1.6c0.1,0,0.2,0,0.4,0c1.1,0,2.1-0.4,2.9-1.1 l27-23.2h30.7c5.2,0,10.1-2,13.8-5.7c3.7-3.7,5.7-8.6,5.7-13.8V30.4C108.8,25.2,106.7,20.3,103,16.6z M31.8,81.4v-0.3h-5 c-2.8,0-5.4-1.1-7.4-3.1s-3.1-4.6-3.1-7.4V30.4c0-2.8,1.1-5.4,3.1-7.4s4.6-3.1,7.4-3.1h62.4c2.8,0,5.4,1.1,7.4,3.1 c2,2,3.1,4.6,3.1,7.4v40.3c0,2.8-1.1,5.4-3.1,7.4c-2,2-4.6,3.1-7.4,3.1H56.9c-1.2,0-2.3,0.5-3.2,1.3L33.9,99.5L34.8,86 C35,83.9,33.7,82.1,31.8,81.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4,44.5H63.5V30.6c0-3-2.5-5.5-5.5-5.5h-0.4c-3,0-5.5,2.5-5.5,5.5v13.9H38.1c-3,0-5.5,2.5-5.5,5.5v0.4 c0,3,2.5,5.5,5.5,5.5h13.9v13.9c0,3,2.5,5.5,5.5,5.5H58c3,0,5.5-2.5,5.5-5.5V55.9h13.9c3,0,5.5-2.5,5.5-5.5V50 C82.9,46.9,80.4,44.5,77.4,44.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewMessage);
export default __webpack_public_path__ + "static/media/icon-new-message.b1b2628d9bf9dd16412f4d6148f837c9.svg";
export { ForwardRef as ReactComponent };